import { showNotification } from '@mantine/notifications'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '..'

export const deleteSmsRecipient = (alertRuleId: string, recipientId: string) =>
  api.delete(`/v1/alert-rules/${alertRuleId}/sms-recipients/${recipientId}`)

export const useDeleteSmsRecipient = (alertRuleId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (recipientId: string) =>
      deleteSmsRecipient(alertRuleId, recipientId),
    onSuccess: () => {
      queryClient.invalidateQueries(['alertRule', alertRuleId, 'smsRecipients'])
      showNotification({
        message: 'SMS recipient removed successfully',
        color: 'green',
      })
    },
    onError: () => {
      showNotification({
        message: 'Failed to remove SMS recipient',
        color: 'red',
      })
    },
  })
}
